// @flow
import styled, { css } from "styled-components";

export const SingleInput = styled.input`
  margin: 0 7px;
  width: 185px;
  min-width: 185px;
  height: 44px;
  letter-spacing: 15px;
  font-size: 22px;
  text-align: center;
  padding-left: 15px;
  color: #4e2a81;
  border: none;
  border-bottom: 2px solid
    ${props => (props.invalid ? props.theme.lower : "#cccccc")};
  border-radius: 0;
  background-color: transparent;
  appearance: none;

  :focus {
    outline: none;
  }

  @media (min-width: 960px) {
    width: 100px;
    font-size: 20px;
    height: 30px;
    border-bottom-width: 1px;
  }
`;

export const Container = styled.div`
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  -webkit-align-self: stretch;
  align-self: stretch;
  width: 100%;
  max-width: 1179px;
  margin: 0 auto 20px auto;
`;

export const Tabs = styled.div`
  direction: ${props => props.theme.direction};
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  max-width: 1179px;
  min-height: 48px;
  margin: 0 auto;
  background: #fff;
  user-select: none;
  overflow: hidden;

  @media (max-width: 959px) {
    margin-bottom: 20px;
  }
`;

export const Content = styled(Container)`
  text-align: left;

  @media (max-width: 959px) {
    padding: 0 16px;
  }

  @media (min-width: 960px) {
    -webkit-flex-grow: 0;
    flex-grow: 0;
    -webkit-align-self: auto;
    align-self: auto;
    margin-top: 33px;
    padding: 24px;
    background-color: #f6f6f6;
    border-radius: 4px;
  }
`;

export const MainHeading = styled.h1`
  padding-top: 1em;
  font-weight: 300;
  font-size: 30px;
  line-height: 1.25;
  text-align: center;
  color: #343434;
`;

export const Subheading = styled.div`
  direction: ${props => props.theme.direction};
  margin-bottom: 2em;
  padding-top: 0.5em;
  font-weight: 400;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1.45;
  text-align: center;
  color: #a7a7a7;
`;

export const Heading = styled.h2`
  padding-bottom: ${props => (props.noPadding ? 0 : "1.25em")};
  font-size: 16px;
  line-height: 1.375;
  text-align: center;
  color: #343434;

  @media (min-width: 960px) {
    font-size: 20px;
  }
`;

export const FieldContainer = styled.div`
  width: 100%;
  text-align: center;
  margin: 0 auto 0;

  @media (min-width: 960px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: space-between;
    justify-content: space-around;
    max-width: 460px;
  }
`;

export const FakeLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: #3498db;
  @media (max-width: 959px) {
    margin-bottom: 15px;
  }
`;

export const CodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-content: space-between;
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;

  @media (min-width: 960px) {
    margin-top: 20px;
  }

  @media (max-width: 959px) {
    flex-direction: column;
  }

  ${props =>
    props.compact &&
    css`
      margin-top: 0;
      padding: 5px 0;

      @media (min-width: 960px) {
        margin-top: 0;
      }
    `};
`;

export const CodeInput = styled.input.attrs({
  type: "tel",
  maxLength: "1"
})`
  margin: 0 7px;
  width: 37px;
  min-width: 37px;
  height: 44px;
  font-size: 22px;
  text-align: center;
  color: #4e2a81;
  border: none;
  border-bottom: 2px solid
    ${props => (props.invalid ? props.theme.lower : "#cccccc")};
  border-radius: 0;
  background-color: transparent;
  appearance: none;

  :focus {
    outline: none;
  }

  @media (min-width: 960px) {
    width: 20px;
    font-size: 20px;
    height: 30px;
    border-bottom-width: 1px;
  }

  ${props =>
    props.compact &&
    css`
      font-size: 18px;
      width: 20px;
      min-width: 20px;

      @media (min-width: 960px) {
        font-size: 18px;
        width: 20px;
        min-width: 20px;
      }
    `};
`;



// WEBPACK FOOTER //
// ./src/components/ReVerification/style.jsx